import { useContext } from 'react'

import AppProcessingContext from 'context/AppProcessingContext'

const useAppProcessingContext = () => useContext(AppProcessingContext)

export default useAppProcessingContext